import Vue from "vue";
import Vuex from "vuex";
import blocks from "./modules/blocks";
import general from "./modules/general";
import user from "./modules/user";
import alias from "./modules/alias";
import comments from "./modules/comments";
import toasts from "./modules/toasts";
import preferences from "./modules/preferences";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    blocks,
    general,
    user,
    alias,
    comments,
    toasts,
    preferences
  }
});
